export function begin(state = {}, STATUS_NAME) {

    return (
        {
            ...state,
            status: {
                ...state.status,
                [STATUS_NAME]: {
                    pending: true,
                    error: null,
                }
            }
        }
    );
}

export function success(state, STATUS_NAME){

    return (
        {
            ...state,
            status: {
                ...state.status,
                [STATUS_NAME]: {
                    pending: false,
                    error: null,
                }
            }
        }
    );
}

export function error(state, STATUS_NAME, error, show = true){

    return (
        {
            ...state,
            status: {
                ...state.status,
                [STATUS_NAME]: {
                    pending: false,
                    error: error
                }
            }
        }
    );
}

//dismiss_error
export function dismiss(state, STATUS_NAME){

    return (
        {
            ...state,
            status: {
                ...state.status,
                [STATUS_NAME]: {
                    ...state.status[STATUS_NAME],
                    error: null,
                }
            }
        }
    );
}

export default {
    begin,
    success,
    error,
    dismiss
}


// WEBPACK FOOTER //
// ./src/helper/redux.js